import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { User } from "../core/models/auth.models";
import { CookieService } from "../core/services/cookie.service";
import { Observable } from "rxjs";
// const getCalenderData  = `http://localhost:3000/api2/GetCountOfUser?endDate=2014-08-28&startDate =2014-08-24`;
//
// const baseurl = `http://localhost:3000/`; //local

// const baseurl = `https://devds.proplegit.com/`; // Dev

// const baseurl = `https://qaapi.jahernotice.com/`; //QA
// const dynamicURL = `https://qads.jahernotice.com/api`; //QA
// const pyurl = `https://qaadmpy.jahernotice.com/`; //QA

// const dynamicURL = `http://localhost:3000/api`; //Local Dev

// const baseurl = `http://localhost:3000/`; //Local Dev
// const pyurl = `http://localhost:3000/`; //Local Dev

// const baseurl = `https://uat-api.jahernotice.com/`; //UAT
// const pyurl = `https://uatadmpy.jahernotice.com/`; //UAT

const baseurl = `https://services.jahernotice.com/`; //live
const dynamicURL = `https://ds.jahernotice.com/api`; //live
const pyurl = `https://admpy.jahernotice.com/`; //live

const state = `${dynamicURL}/state/list/`;
const getCalenderData_1 = `${baseurl}api2/GetCountOfUser`;

// Python
const corpusDashboard = `${pyurl}dashboard`;
const newsPaper = `${pyurl}newspaper-time-update`;

const getAllAuction = `${baseurl}`;
// EPP api
const getEppByUserName = `${baseurl}api/UserEpp`;
const getLawyerData = `${baseurl}api2/getLawyer/data`;
const getLawyerDetails = `${baseurl}api2/getNoticeList/byLawyer`;
const getTpByUserName = `${baseurl}api/userlist`;
const postepp = `${baseurl}api/addEpp`;
const getEdition = `${pyurl}api/editions`;
const getNoticeType = `${baseurl}api2/NoticeType`;
const getNewspaper = `${pyurl}api/newspapers`;
const postusers = `${baseurl}api/add/tpa`;
const getall = `${baseurl}api/Epp`;
const getServiceDetails = `${baseurl}api/tpuser`;
const getallTp = `${baseurl}api/tpservice/count`;
const getallusers = `${baseurl}api2/userList`;
const EppByUserID = `${baseurl}api/EppByID/`;
const getAllByEppSub = `${baseurl}api/EppID/`;
const getAdminUser = `${baseurl}api/AdminUser`;
const getDEOUser = `${baseurl}api/deo/AdminUser`;
const putEpp = `${baseurl}api/EditUser/`;
const service = `${baseurl}api/tpservice`;
const serviceIntrest = `${baseurl}api/service/interest`;
const subservice = `${baseurl}api/tpsubservice`;
const getEpp = `${baseurl}api/UserList`;
const getLawyers = `${baseurl}api2/LawyerByLawyerName/`;
const getPlanDetails = `${baseurl}api2/plan`;
const postnewepp = `${baseurl}api/AddNewEpp`;
const delet = `${baseurl}api/inactive/`;
const active = `${baseurl}api/active/`;
const register = `${baseurl}Admin/SignUp`;
const generateOTP = `${baseurl}Admin/OTP/resend`;
const validateOTP = `${baseurl}Admin/OTP/verify`;
const EditByUserId = `${baseurl}api/EditByUserID/`;
const getTPByID = `${baseurl}api/gettpuserdata/`;
const approvenotice = `${baseurl}api2/AddDataToContent/`;
// Auction Api
const getAllauction = `${baseurl}api/auction/subscriber/view`;
const getAuctionNoticeType = `${baseurl}api/AuctionNoticeType`;
const getAuctionFor = `${baseurl}auction/service/type`;
const getUser = `${baseurl}api/user/detail/search`;
const subtype = `${baseurl}api/auction/service/type`;
const district = `${baseurl}api3/District`;
const getReceiptType = `${baseurl}api2/GetReceiptType`;
const getReceiptPaymentType = `${baseurl}api2/get/paymentType`;
const taluka = `${baseurl}api/Taluka/`;
const village = `${baseurl}api/Village/`;
const addauction = `${baseurl}api/auction/subscriber/Insert/`;
const Auctionbyid = `${baseurl}api/auction/subscriber/view/`;
const putauction = `${baseurl}api/auction/update/`;
const isActive = `${baseurl}api/tp/isactive`;
const isDeactivate = `${baseurl}api/tp/deactive`;
const AddActionExcelData = `${baseurl}api/AddActionNotice`;
const GETAuctionAlertDetails = `${baseurl}api/AuctionEmailAlert/`;
const AuctionEmailSend = `${baseurl}api/AuctionEmailSend`;
const GETAuction = `${baseurl}api/ActionNotice`;
const updateSubscriptionPlan = `${baseurl}api2/update/plan`;
const GETUserReceipts = `${baseurl}api2/viewReceipt`;
const AddReceipt = `${baseurl}api2/sendQuotation`;
const updateReceipt = `${baseurl}api2/updatePaymenttype`;
const GETLandRecordOrders = `${baseurl}api2/landRecordOrders`;
const GETLandRecordOrderPrefill = `${baseurl}api2/landRecordOrder`;
const addSociety = `${baseurl}api2/Society2`;
const Societylist = `${baseurl}api2/getSociety/data`;
const addLawyer = `${baseurl}api2/Lawyer`;
const uploadNotice = `${baseurl}api2/insertdeocontent`;
const updateNotice = `${baseurl}api2/qcUpdateNotice`;
const getWhatsappReport = `${baseurl}api/whatsapp-report`;
const fetchNoticeID = `${baseurl}api2/getNoticeID`;
const updateFinalNotice = `${baseurl}api2/updatecontent`;
const downloadExcel = `${baseurl}api/downloadXL`;
const downloadDeoExcel = `${baseurl}api/deo/downloadXL`;
const getdeo_content_data = `${baseurl}api2/getdeo_content_data`;
const getDEOQCAutomation = `${baseurl}api2/getdeo_content_data_automation`;
const getDEOQCIrrelevant = `${baseurl}api2/getirrelevant_notices`;
const noticeTracking = `${baseurl}api2/NoticeTrack/`;
const getfinal_content_data = `${baseurl}api2/getcontent_data`;
const getNoticeData = `${baseurl}api2/getdeo_content_data/byid`;
const getNoticeDataAuctomation = `${baseurl}api2/getdeo_content_data_automation/byid`;
const getCountOfUser = `${baseurl}api2/GetCountOfUser`;
const getcallAlertUserDetails = `${baseurl}api2/user/details/call/alert/page`;
const callAlertUserDetails = `${baseurl}api2/userListbyID`;
const getCallAlertList = `${baseurl}api2/callalert/list/`;
const getUserServiceDetails = `${baseurl}api/service/interest/`;
const getCallAlertType = `${baseurl}api2/call/alert/type`;
const getCallInitiatedFrom = `${baseurl}api2/get/call/initiated/from`;
const getActivationStatus = `${baseurl}api2/get/activation/status`;
const addCallAlert = `${baseurl}api2/add/call/alert`;
const addFranchiseUser = `${baseurl}api2/AddUser`;
const updateFranchiseUser = `${baseurl}api2/editUserProfile`;
const callAlertList = `${baseurl}api2/get/callatert/list/date`;
const amountGraphData = `${baseurl}api2/amount/graph/data`;
const statusList = `${baseurl}api/StatusList`;
const getSubscriberList = `${baseurl}api2/GETSubscriberList`;
const uploadNoticeImages = `${baseurl}api2/upload/notice/images`;
const uploadBulkNotices = `${baseurl}api2/upload/notice/Excel`;
const uplodaBulkNoticeUrban = `${baseurl}api2/upload/urban/notice/Excel`;
const getnewspaper = `${baseurl}api2/getNewspaper/list`;
const addNewspaper = `${baseurl}api2/AddNewspaper`;
const updateNewspaper = `${baseurl}api2/UpdateNewspaper/byID`;
const getEdition1 = `${baseurl}api2/getEdition/list`;
const addEdition = `${baseurl}api2/AddEdition`;
const updateLawyer = `${baseurl}api2/UpdateLawyer/byID/`;
const updateEdition = `${baseurl}api2/UpdateEdition/byID`;
const AddProperty = `${baseurl}api2/add/propertyDetails`;
const getPropertylist = `${baseurl}api2/get/propertyDetails`;
const deletePropertylist = `${baseurl}api2/del/propertyDetails`;
const editProperty = `${baseurl}api2/edit/propertyDetails`;
const areaAlertList = `${baseurl}api2/get/AreaAlertDetails`;
const deleteArealert = `${baseurl}api2/del/AreaAlert`;
const getTPlist = `${baseurl}api/gettpuserdata/`;
const addTP = `${baseurl}api/add/tpa`;
const addEPP = `${baseurl}api/addEpp`;
const addAreaAlert = `${baseurl}api2/add/AreaAlert`;
const editAreaAlert = `${baseurl}api2/edit/AreaAlertDetails`;
const getAreaDeatail = `${baseurl}api2/get/AreaAlertDetails`;
const viewEPP = `${baseurl}api/EppByID/`;
const addNewEpp = `${baseurl}api/AddNewEpp`;
const auctionAlertList = `${baseurl}api/auction/subscriber/view/ByUserID/`;
const Updateauction = `${baseurl}api/auction/update/`;
const Addauction = `${baseurl}api/auction/subscriber/Insert/`;
const editEPP = `${baseurl}api/EditByUserID/`;
const getSMSAreaAlert = `${baseurl}api2/getAreaAlert/logByUserID/`;
const getSMSPP = `${baseurl}api2/getPropertyProtection/SMSlogByUserID/`;
const getEmailPP = `${baseurl}api2/getPropetyProtection/EmaillogByUserID/`;
const getEmailEPP = `${baseurl}api2/getEPP/EmaillogByUserID/`;
const getEmailTP = `${baseurl}api2/getTP/EmaillogByUserID/`;
const AuctionbyId = `${baseurl}api/auction/subscriber/view/`;
const EmailAuction = `${baseurl}api2/getAuctionNotice/ByUserID/`;
const getEmailAlert_data = `${baseurl}api2/getAreaAlert/EmaillogByUserID/`;
const userDistrictList = `${baseurl}api2/userDistrict/ByUserId`;
const deleteUserDetail = `${baseurl}api2/delete/userDistrict/ByUserId`;
const addUserDetail = `${baseurl}api2/add/userDistrict/ByUserId`;
const LRSUserlist = `${baseurl}api2/getLRSUser/data`;
const LRSUploadDoc = `${baseurl}api/upload/Document`;
const newMobile = `${baseurl}api2/add/newlogin/mobileno`;
const State = `${baseurl}api/State`;
const getLrs = `${baseurl}api/get/LRSservicesList/bystateID`;
const addLrs = `${baseurl}api/add/LRS/Services`;
const editLrs = `${baseurl}api/update/LRS/Services`;
const LRSCount = `${baseurl}api/get/LRS_Userstatus/count/`;
const LRSState = `${baseurl}api/State`;
const SMSAreaAlert = `${baseurl}api2/getAreaAlert/SMSlog`;
const EmailAreaAlert = `${baseurl}api2/getAreaAlert/Emaillog`;
const SMSSurveyAlert = `${baseurl}api2/getSurveyAlert/SMSlog`;
const EmailSurveyAlert = `${baseurl}api2/getSurveyAlert/Emaillog`;
const SendSurveySMS = `${baseurl}api2/survey/sms/send_user_sms_notification`;
const SurveySmsPreview = `${baseurl}api2/survey/sms/preview`;
const SendSurveyEmail = `${baseurl}api2/survey/email/send_user_email_notification`;
const SurveyAlertUserDetail = `${baseurl}api2/getSurveyAlert/userDetail`;
const loginReport = `${baseurl}api/login/details`;
const CallDate = `${baseurl}api2/get/callatert/list/date/by/calldate/`;
const viewLoginReport = `${baseurl}api/loginreport/byuserID/`;
const IsAuction = `${baseurl}api/AddActionNotice`;
const AuctionAlert = `${baseurl}api/AuctionEmailAlert/`;
const AuctionNotice = `${baseurl}api/ActionNotice`;
const dailyreportExcel = `${baseurl}api/downloadCallAlertXL`;
const callReportExcel = `${baseurl}api/downloadCallAlertXL`;
const editAuction = `${baseurl}api/auction/details/id`;
const tpServices = `${baseurl}api/tpservice`;
const Isrelevant = `${baseurl}api2/insertContentInApplicable`;
const SaveAndNext = `${baseurl}api/verify-save-next`;
const replaceNoticeImage = `${baseurl}api2/replaceNoticeImage`;

const QueueNotice = `${baseurl}api/queue-notices/`;

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};
const httpOptionsURLEncoded = {
  headers: new HttpHeaders().set(
    "Content-Type",
    "application/x-www-form-urlencoded"
  ),
};
const headers = {
  headers: new HttpHeaders().set("enctype", "multipart/form-data"),
};
const httpFileUploadOptions = {
  headers: new HttpHeaders(),
};

@Injectable({
  providedIn: "root",
})
export class GeneralService {
  private userID: number;
  user: User;
  constructor(private http: HttpClient, private cookieService: CookieService) {}

  getImagePathURL(path: string | null): string | null {
    if (!path) return null;

    let finalPath = path.trim();

    // Check if already a full URL
    if (/^https?:\/\//i.test(finalPath)) {
      // Ensure extension
      const cleanUrl = finalPath.split("?")[0].split("#")[0];
      const hasExt = /\.[a-zA-Z0-9]+$/.test(cleanUrl);
      return hasExt ? finalPath : `${finalPath}.jpg`;
    }

    // Otherwise it's a short name → prefix with base URL
    const hasExt = /\.[a-zA-Z0-9]+$/.test(finalPath);
    return hasExt
      ? `${getAllAuction}${finalPath}`
      : `${getAllAuction}${finalPath}.jpg`;
  }

  // Epp
  getBaseurl(): any {
    return baseurl;
  }
  tpServices() {
    return this.http.get(`${tpServices}`, httpOptions);
  }
  Societylist(id) {
    return this.http.get(`${baseurl}api2/Societyurban?villageid=${id}`);
  }
  SocietylistUrban(id) {
    return this.http.get(`${baseurl}api2/Societyurban?wardid=${id}`);
  }
  SocietylistGoaUrban(id) {
    return this.http.get(`${baseurl}api2/Societyurban?CityID=${id}`);
  }
  getservices() {
    return this.http.get(`${baseurl}api2/service/`, httpOptions);
  }
  getServicesSubType(ServiceID: number, stateID: any) {
    return this.http.get(`${baseurl}api2/service/subtype/${ServiceID}`, {
      params: { state: stateID },
      ...httpOptions,
    });
  }
  getServicePurpose() {
    return this.http.get(`${baseurl}api2/purpose`, httpOptions);
  }
  getUserServiceDetails(id) {
    return `${getUserServiceDetails}${id}`;
  }
  CallDate() {
    return CallDate;
  }
  Isrelevant(data, params) {
    return this.http.post(`${Isrelevant}${params}`, data);
  }
  SaveAndNext(data, params) {
    return this.http.post(`${SaveAndNext}/${params}`, data);
  }
  QueueNotice(module: string, stateId: number, userId: number, docId?: number) {
    let url = `${QueueNotice}${module}/${stateId}/${userId}`;

    // ✅ Append only when DocID is provided
    if (docId !== undefined && docId !== null) {
      url += `?DocID=${docId}`;
    }

    return this.http.get(url, httpOptions);
  }
  replaceQCNoticeImage(data: FormData) {
    return this.http.post(replaceNoticeImage, data);
  }
  updateIrrelevantNotice(noticeId: number, data: FormData, params: string) {
    return this.http.post(`${Isrelevant}/${noticeId}${params}`, data);
  }
  postServices(data: any) {
    return this.http.post(`${serviceIntrest}`, data, httpOptions);
  }
  getallLrs(): any {
    return getLrs;
  }
  getstate(): any {
    return this.http.get(State, httpOptions);
  }
  getCalenderRange(formattedStartDate: any, formattedEndDate: any) {
    return this.http.get(
      `${getCalenderData_1}?endDate=${formattedEndDate}&startDate=${formattedStartDate}`
    );
  }
  getTPByID() {
    return getTPByID;
  }
  SMSAreaAlert() {
    return SMSAreaAlert;
  }
  AuctionNotice() {
    return AuctionNotice;
  }
  AuctionAlert(date, Filtertype) {
    return this.http.get(`${AuctionAlert}${date}?FilterField=${Filtertype}`);
  }
  editAuction(id) {
    return this.http.get(`${editAuction}/${id}`, httpOptions);
  }
  viewLoginReport() {
    return viewLoginReport;
  }
  EmailAreaAlert() {
    return EmailAreaAlert;
  }
  SMSSurveyAlert() {
    return SMSSurveyAlert;
  }
  EmailSurveyAlert() {
    return EmailSurveyAlert;
  }
  SendSurveySMS() {
    return SendSurveySMS;
  }
  SurveySmsPreview() {
    return SurveySmsPreview;
  }
  SendSurveyEmail() {
    return SendSurveyEmail;
  }
  SurveyAlertUserDetail() {
    return SurveyAlertUserDetail;
  }
  LRSState() {
    return this.http.get(LRSState, httpOptions);
  }
  // LRSStateSearch(id){
  //   return this.http.get(`${LRSState}?SearchKey=${id}`,httpOptions);
  // }
  LRSStateSearch(id, stateID) {
    return this.http.get(
      `${LRSUserlist}/${id}?SearchKey=${stateID}`,
      httpOptions
    );
  }
  dailyreportExcel() {
    return dailyreportExcel;
  }
  callReportExcel() {
    return callReportExcel;
  }
  getLawyerData() {
    return getLawyerData;
  }
  UserDistrictWise(Userid) {
    return this.http.get(`${baseurl}api2/get/district/byuserID/${Userid}`);
  }
  UserTalukaList(id) {
    return this.http.get(`${baseurl}api2/Taluka/${id}`);
  }
  UserVillageList(id) {
    return this.http.get(`${baseurl}api2/Village/${id}`);
  }
  getTPlist() {
    return getTPlist;
  }
  addLrs(data) {
    return this.http.post(`${addLrs}`, data);
  }
  getInsertauction(UsersubscriptionMainID: any): any {
    return this.http.get(
      `${AuctionbyId}${UsersubscriptionMainID}`,

      httpOptions
    );
  }
  LRSUser() {
    return LRSUserlist;
  }
  getLRSUserList(id) {
    return this.http.get(`${LRSUserlist}/${id}`, httpOptions);
  }
  newMobile(data) {
    return this.http.post(`${newMobile}`, data, httpOptions);
  }
  getnewspaper() {
    return getnewspaper;
  }
  getPropertylist() {
    return getPropertylist;
  }
  areaAlertList() {
    return areaAlertList;
  }
  getSMSAreaAlert() {
    return getSMSAreaAlert;
  }
  getEmailEPP() {
    return getEmailEPP;
  }
  EmailAuction() {
    return EmailAuction;
  }
  getEmailTP() {
    return getEmailTP;
  }
  getSMSPP() {
    return getSMSPP;
  }
  getEmailAlert_data() {
    return getEmailAlert_data;
  }
  IsAuction(data) {
    return this.http.post(`${IsAuction}`, data);
  }
  Addnewspaper(data): any {
    return this.http.post(`${addNewspaper}`, data);
  }
  Addedition(data) {
    return this.http.post(`${addEdition}`, data);
  }
  LRSUploadDoc(data, id) {
    return this.http.post(`${LRSUploadDoc}?AdhocDeliveryID=${id}`, data);
  }
  getLawyerDetails() {
    return getLawyerDetails;
  }
  LRSCount(id) {
    return this.http.get(`${LRSCount}${id}`, httpOptions);
  }
  getEPP() {
    return viewEPP;
  }
  getdeo_content_data() {
    return getdeo_content_data;
  }
  getdeo_content_data_automation() {
    return getDEOQCAutomation;
  }
  getdeo_irrelevant_notice_data_automation() {
    return getDEOQCIrrelevant;
  }
  noticeTracking(
    noticeId: number,
    AdminUserID: number,
    stateID: number,
    createdBy?: number
  ) {
    let url = `${noticeTracking}${noticeId}`;
    const params: string[] = [];

    if (createdBy !== undefined && createdBy !== null) {
      params.push(`createdBy=${createdBy}`);
    }

    // stateID is required, so just add it directly
    params.push(`stateID=${stateID}`);

    url += `?${params.join("&")}`;

    return this.http.post(url, { AdminUserID });
  }

  // noticeTrackingDEO(
  //     noticeId: number,
  //     AdminUserID: number,
  //     stateID: number,
  //     createdBy?: number
  // ) {
  //     let url = `${noticeTracking}${noticeId}`;
  //     const params: string[] = [];

  //     if (createdBy) {
  //         params.push(`createdBy=${createdBy}`);
  //     }

  //     if (stateID) {
  //         params.push(`stateID=${stateID}`);
  //     }

  //     if (params.length > 0) {
  //         url += `?${params.join('&')}`;
  //     }

  //     return this.http.post(url, { AdminUserID });
  // }

  noticeTrackingAutomation(
    noticeId: number,
    AdminUserID: number,
    stateID: number,
    createdBy: number
  ) {
    let url = `${noticeTracking}${noticeId}`;
    const params: string[] = [];

    params.push(`createdBy=${createdBy}`);

    params.push(`stateID=${stateID}`);

    url += `?${params.join("&")}`;

    return this.http.post(url, { AdminUserID });
  }

  noticeTrackingQC(noticeId: number, body: any, params: string = "") {
    return this.http.post(
      `${baseurl}api2/NoticeTrack/${noticeId}${params}`,
      body
    );
  }
  noticeTrackingQCWithFilters(noticeId: number, queryParams: string) {
    return this.http.get(
      `${baseurl}api2/NoticeTrack/${noticeId}?${queryParams}`
    );
  }
  PendingNotices() {
    return this.http.post(`${baseurl}api2/PendingNotices`, {});
  }
  deletePendingNotice(payload: { NoticeID: number }) {
    return this.http.post(`${baseurl}api2/PendingNotices`, payload);
  }
  deleteAllPendingNotices(payload: { unAssignAll: boolean }) {
    return this.http.post(`${baseurl}api2/PendingNotices`, payload);
  }
  getfinal_content_data() {
    return getfinal_content_data;
  }
  getusereppbyid(id) {
    return this.http.get(`${baseurl}api/EppByID/${id}`, httpOptions);
  }

  getusertpbyid(id) {
    return this.http.get(`${baseurl}api/tpservice/count/${id}`, httpOptions);
  }
  approvenotice(id) {
    return this.http.post(`${approvenotice}${id}`, httpOptions);
  }
  getusersbyid(id) {
    return this.http.get(`${baseurl}api2/userListbyID/${id}`, httpOptions);
  }
  userDistrictList() {
    return userDistrictList;
  }
  addUserDistrict(data: any) {
    return this.http.post(`${addUserDetail}`, data, httpOptions);
  }
  deleteUserDetail(id) {
    return this.http.delete(`${deleteUserDetail}?id=${id}`, httpOptions);
  }
  viewDistrictlist() {
    return this.http.get(`${baseurl}api2/District`, httpOptions);
  }
  getPlanDetails(id) {
    return this.http.get(`${getPlanDetails}/${id}`, httpOptions);
  }
  downloadExcel(): any {
    return downloadExcel;
  }
  downloadDeoExcel(): any {
    return downloadDeoExcel;
  }
  getEpp(url: any): any {
    return this.http.get(`${getEppByUserName}/${url}`, httpOptions);
  }
  getTp(url: any): any {
    return this.http.get(`${getTpByUserName}/${url}`, httpOptions);
  }
  AddEPP(data): any {
    return this.http.post(`${postepp}`, data, httpFileUploadOptions);
  }
  addAreaAlert(data: any) {
    return this.http.post(`${addAreaAlert}`, data, httpOptions);
  }
  addTP(data) {
    return this.http.post(`${addTP}`, data, httpOptions);
  }
  addNewEpp(data) {
    return this.http.post(`${addNewEpp}`, data, httpOptions);
  }
  addEPP(data) {
    return this.http.post(`${addEPP}`, data, httpOptions);
  }
  editLrs(data, AdhocServiceID) {
    return this.http.post(`${editLrs}/${AdhocServiceID}`, data);
  }
  getupdateLrs(AdhocServiceID): any {
    return this.http.get(
      `${getLrs}?AdhocServiceID=${AdhocServiceID}`,
      httpOptions
    );
  }
  AddReceipt(data): any {
    return this.http.post(`${AddReceipt}`, data, httpOptions);
  }
  isActive(data): any {
    return this.http.post(`${isActive}`, data, httpOptions);
  }
  isDeactivate(data) {
    return this.http.post(`${isDeactivate}`, data, httpOptions);
  }
  AddTP(data): any {
    return this.http.post(`${postusers}`, data, httpFileUploadOptions);
  }
  editAreaAlert(id, data) {
    return this.http.post(`${editAreaAlert}?id=${id}`, data, httpOptions);
  }
  editEPP(id, data) {
    return this.http.put(`${editEPP}${id}`, data, httpOptions);
  }
  auctionAlertList() {
    return auctionAlertList;
  }
  Addauction(UserID: any, data): any {
    return this.http.post(
      `${Addauction}${UserID}`,
      data,
      httpFileUploadOptions
    );
  }
  Updateauction(userEPPSubscription: any, data): any {
    return this.http.put(
      `${Updateauction}${userEPPSubscription}`,
      data,
      httpOptions
    );
  }
  updateLawyer(id, data) {
    return this.http.post(`${updateLawyer}${id}`, data, httpOptions);
  }
  UpdateSociety(id, data) {
    return this.http.post(
      `${baseurl}api/UpdateSociety/${id}`,
      data,
      httpOptions
    );
  }
  FetchAreaDeatail(UserId: any, id: any) {
    return this.http.get(
      `${getAreaDeatail}?UserID=${UserId}&pageNo=1&PageSize=10&search=${id}`,
      httpOptions
    );
  }
  getEmailPP() {
    return getEmailPP;
  }
  getallEpp(): any {
    return getall;
  }
  GETUserReceipts(): any {
    return GETUserReceipts;
  }
  dataEdition(id: any) {
    return this.http.get(`${getEdition1}?PageSize=10&pageNo=1&id=${id}`);
  }
  updateedition(id, data) {
    return this.http.post(`${updateEdition}?id=${id}`, data);
  }
  GETUserAllReceipts(user_id): any {
    return this.http.get(`${GETUserReceipts}/${user_id}`, httpOptions);
  }
  updateReceipt(data): any {
    return this.http.post(`${updateReceipt}`, data, httpOptions);
  }
  /** Land Record orders (tblUserAdhocDelivery) of a user with their receipt status */
  getLandRecordOrders(user_id): any {
    return this.http.get(`${GETLandRecordOrders}/${user_id}`, httpOptions);
  }
  /** Excel export URL for the Land Record Orders list (same filters, no paging) */
  getLandRecordOrdersExportUrl(params: {
    q?: string;
    dateFrom?: string;
    dateTo?: string;
    payment?: string;
    receipt?: string;
  }): string {
    const qs = Object.keys(params)
      .filter((k) => params[k] !== undefined && params[k] !== null && params[k] !== "")
      .map((k) => `${k}=${encodeURIComponent(params[k])}`)
      .join("&");
    return `${GETLandRecordOrders}/export${qs ? "?" + qs : ""}`;
  }
  /** ALL Land Record orders, server-side paged + filtered ("Land Record Orders" screen) */
  getLandRecordOrdersList(params: {
    PageNo: number;
    PageSize: number;
    q?: string;
    dateFrom?: string;
    dateTo?: string;
    payment?: string;
    receipt?: string;
  }): any {
    const qs = Object.keys(params)
      .filter((k) => params[k] !== undefined && params[k] !== null && params[k] !== "")
      .map((k) => `${k}=${encodeURIComponent(params[k])}`)
      .join("&");
    return this.http.get(`${GETLandRecordOrders}?${qs}`, httpOptions);
  }
  /** Add-Receipt prefill (services / payment / bill-to) for one Land Record order */
  getLandRecordOrderReceiptPrefill(adhocDeliveryId): any {
    return this.http.get(
      `${GETLandRecordOrderPrefill}/${adhocDeliveryId}/receiptPrefill`,
      httpOptions
    );
  }
  getEppById(userEPPSubscription: any): any {
    return this.http.get(
      `${getAllByEppSub}${userEPPSubscription}`,
      httpOptions
    );
  }
  getNoticeData(id, userId = null): any {
    return this.http.get(`${getNoticeData}?id=${id}&u=${userId}`, httpOptions);
  }
  getNoticeDataAutomation(id): any {
    return this.http.get(`${getNoticeDataAuctomation}?id=${id}`, httpOptions);
  }
  getNoticeDataimage(): Observable<any> {
    return this.http.get<any>(`${baseurl}api/notice`);
  }
  deleteArealert(id) {
    return this.http.post(`${deleteArealert}?id=${id}`, httpOptions);
  }
  deletePropertylist(id) {
    return this.http.post(`${deletePropertylist}?id=${id}`, httpOptions);
  }
  editProperty(id, data) {
    return this.http.post(`${editProperty}?id=${id}`, data, httpOptions);
  }
  FetchProperty(id, userId) {
    return this.http.get(
      `${getPropertylist}?UserID=${userId}&search=${id}&orderKey=&ordering=desc&PageSize=10&pageNo=1`,
      httpOptions
    );
  }
  getAllServiceCount(id) {
    return this.http.get(
      `${baseurl}api2/GetCountofAllSMSEmailLogServices/ByUserID/${id}`
    );
  }
  getAllCount(id) {
    return this.http.get(`${baseurl}api2/getAllServices_subOrdone/count/${id}`);
  }
  AllServiceCount(id) {
    return this.http.get(`${baseurl}api2/getAllServices/count/${id}`);
  }
  FetchLawyer(id) {
    return this.http.get(`${getLawyerData}?PageSize=10&pageNo=1&search=${id}`);
  }
  FetchSoceity(id) {
    return this.http.get(
      `${Societylist}?PageSize=10&pageNo=1&search=${id}`,
      httpOptions
    );
  }
  FetchTP(id, userId) {
    return this.http.get(
      `${getTPlist}${userId}?PageSize=10&PageNo=1&SearchKey=${id}`
    );
  }
  Updatenewspaper(id, data): any {
    return this.http.post(`${updateNewspaper}?id=${id}`, data);
  }
  getnewspaperlist(id: any) {
    return this.http.get(`${getnewspaper}?PageSize=10&pageNo=1&id=${id}`);
  }
  getFinalNoticeData(id): any {
    return this.http.get(`${getfinal_content_data}/byid?id=${id}`, httpOptions);
  }
  getEppByUserId(user_id: any): any {
    return this.http.get(`${EppByUserID}${user_id}`, httpOptions);
  }
  UpdateEpp(userID: any, userEPPSubscription: any, data): any {
    return this.http.put(
      `${putEpp}${userID}/${userEPPSubscription}`,
      data,
      httpOptions
    );
  }
  UpdateEppByUserId(user_id: any, data): any {
    return this.http.put(`${EditByUserId}${user_id}`, data, httpOptions);
  }
  getEppUserid(url): any {
    return this.http.get(`${getEpp}/${url}`, httpOptions);
  }
  getLawyers(url): any {
    return this.http.get(`${getLawyers}${url}`, httpOptions);
  }

  AddNew(data): any {
    return this.http.post(`${postnewepp}`, data, httpFileUploadOptions);
  }
  updateSubscriptionPlan(id, data): any {
    return this.http.post(`${updateSubscriptionPlan}/${id}`, data, httpOptions);
  }
  deletbyid(userEPPSubscription: any, data): any {
    return this.http.request("DELETE", `${delet}${userEPPSubscription}`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: { Admin_ID: data },
    });
    // return this.http.delete(`${delet}${userEPPSubscription}`, httpDeleteOptions);
  }
  areabystateid(url, Search, DistrictId?): any {
    if (DistrictId) {
      return this.http.get(`${url}${Search}?DistrictId=${DistrictId}`);
    } else {
      return this.http.get(`${url}${Search}`);
    }
  }
  areabystateid1(StateId, Search): any {
    return this.http.get(
      `${dynamicURL}/area/list/state/${StateId}/district/area/${Search}`
    );
  }
  getServiceDetails(id): any {
    return this.http.get(`${getServiceDetails}/${id}`, httpOptions);
  }

  getallTp() {
    return getallTp;
  }
  getallusers() {
    return getallusers;
  }
  getAllTPUsers(): any {
    return this.http.get(`${getallTp}`, httpOptions);
  }
  Inactive(userEPPSubscription: any, data): any {
    return this.http.post(`${active}${userEPPSubscription}`, data, httpOptions);
  }
  userRegister(userData): any {
    return this.http.post(register, userData, httpOptions);
  }

  // Python
  displayCorpusDashboardPage() {
    return corpusDashboard;
  }
  displayNewspaperPage() {
    return newsPaper;
  }
  // Auction
  getAuction(): any {
    return this.http.get(`${getAllauction}`, httpOptions);
  }
  getAuctionNoticeType(): any {
    return this.http.get(`${getAuctionNoticeType}`, httpOptions);
  }
  getAucFor(): any {
    return this.http.get(`${getAuctionFor}`, httpOptions);
  }
  getUserName(url): any {
    return this.http.get(`${getUser}/${url}`, httpOptions);
  }
  getSubType(): any {
    return this.http.get(`${subtype}`, httpOptions);
  }
  getcurrentUser() {
    return JSON.parse(this.cookieService.getCookie("currentUser"));
  }
  getDistrict(id?): any {
    if (id) {
      return this.http.get(`${dynamicURL}/district/list/${id}`, httpOptions);
    } else {
      return this.http.get(`${dynamicURL}/district/list`, httpOptions);
    }
  }
  getReceiptType(): any {
    return this.http.get(`${getReceiptType}`, httpOptions);
  }
  getReceiptPaymentType(): any {
    return this.http.get(`${getReceiptPaymentType}`, httpOptions);
  }
  getTaluka(DistrictID: any): any {
    return this.http.get(`${taluka}${DistrictID}`, httpOptions);
  }
  getDistrictlist(id) {
    return this.http.get(
      `${baseurl}api/get/village/taluka/district/WithID/${id}`,
      httpOptions
    );
  }
  etUserID(userid: number) {
    this.userID = userid;
  }
  getVillage(TalukaID: any): any {
    return this.http.get(`${village}${TalukaID}`, httpOptions);
  }
  addSociety(data): any {
    return this.http.post(`${addSociety}`, data, httpOptions);
  }
  getsociety() {
    return Societylist;
  }
  addLawyer(data): any {
    return this.http.post(`${addLawyer}`, data, httpOptions);
  }
  uploadNotice(data: FormData, params): any {
    return this.http.post(`${uploadNotice}${params}`, data, headers);
  }
  uploadBulkNotice(data, params): any {
    return this.http.post(`${uploadBulkNotices}${params}`, data, headers);
  }
  uplodaBulkNoticeUrban(data, params): any {
    return this.http.post(`${uplodaBulkNoticeUrban}${params}`, data, headers);
  }
  uploadNoticeImages(data, params): any {
    return this.http.post(`${uploadNoticeImages}${params}`, data, headers);
  }
  updateNotice(data: FormData, params): any {
    return this.http.post(`${updateNotice}${params}`, data, headers);
  }
  // fetchNoticeID() {
  //     return this.http.get(`${fetchNoticeID}`, httpOptions);
  // }

  updateFinalNotice(data, params): any {
    return this.http.post(`${updateFinalNotice}${params}`, data, headers);
  }
  AddAuction(UserID: any, data): any {
    return this.http.post(
      `${addauction}${UserID}`,
      data,
      httpFileUploadOptions
    );
  }
  getauctionbyid(UsersubscriptionMainID: any): any {
    return this.http.get(
      `${Auctionbyid}${UsersubscriptionMainID}`,
      httpOptions
    );
  }
  setUserID(userid: number) {
    this.userID = userid;
  }
  getUserID() {
    return this.userID;
  }
  generateOTP(data): any {
    return this.http.post(`${generateOTP}`, data, httpOptions);
  }
  UpdateAuction(userEPPSubscription: any, data): any {
    return this.http.put(
      `${putauction}${userEPPSubscription}`,
      data,
      httpOptions
    );
  }
  validateOTP(data): any {
    return this.http.post(validateOTP, data, httpOptions);
  }
  downlode_file(url) {
    const downlode_file_url = url;
    let headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/.xls", //give file extension
    });
    let options = { headers: headers };
    return this.http.post(downlode_file_url, options, {
      responseType: "blob",
    });
  }

  /**
   * Returns the current user
   */
  public currentUser(): User {
    if (!this.user) {
      this.user = JSON.parse(this.cookieService.getCookie("currentUser"));
    }
    return this.user;
  }
  service(): any {
    return this.http.get(`${service}`, httpOptions);
  }
  subservice(id): any {
    return this.http.get(`${subservice}/${id}`, httpOptions);
  }
  /**
   * Performs the auth
   * @param EmailOrMobileNo email of user
   * @param Password password of user
   */
  login(EmailOrMobileNo: string, Password: string) {
    return this.http
      .post<any>(`${baseurl}Admin/SignIn`, { EmailOrMobileNo, Password })
      .pipe(
        map((user) => {
          // login successful if there's a jwt token in the response
          if (user && user.data) {
            this.user = user.data;
            this.setUserID(user.data.Id);
            // store user details and jwt in cookie
            // this.cookieService.setCookie('currentUser', JSON.stringify(user), 1);
          }
          return user;
        })
      );
  }
  resetPassword(data) {
    return this.http.post<any>(
      `${baseurl}/Admin/Password/send`,
      data,
      httpOptions
    );
  }
  /**
   * Logout the user
   */
  logout() {
    // remove user from local storage to log user out
    this.cookieService.deleteCookie("currentUser");
    this.user = null;
  }
  getWhatsappReport(date: string, stateId?: number, districtId?: number) {
    let url = `${getWhatsappReport}?date=${date}`;

    if (stateId) url += `&state=${stateId}`;
    if (districtId) url += `&district=${districtId}`;

    return this.http.get(url, httpOptions);
  }

  getState(): any {
    return this.http.get(state, httpOptions);
  }
  getEdition(newspaperid?: number): any {
    let url = getEdition;
    if (newspaperid) {
      url += `?newspaperid=${newspaperid}`;
    }
    return this.http.get(url, httpOptions);
  }

  getNewspaper(stateid?: number): any {
    let url = getNewspaper;
    if (stateid) {
      url += `?stateid=${stateid}`;
    }
    return this.http.get(url, httpOptions);
  }
  getEdition1() {
    return getEdition1;
  }
  getNoticeType(): any {
    return this.http.get(getNoticeType, httpOptions);
  }
  getAdminUser(): any {
    return this.http.get(getAdminUser, httpOptions);
  }
  getDEOUser(): any {
    return this.http.get(getDEOUser, httpOptions);
  }
  getDynamicFields(data) {
    return this.http.post(
      `${dynamicURL}/Dynamicdata`,
      data,
      httpOptionsURLEncoded
    );
  }
  getStateBaseDocTypeByStateID(StateID) {
    return this.http.get(
      `${dynamicURL}/statebasedoctype/list/${StateID}`,
      httpOptions
    );
  }
  dynamicData(URL): any {
    return this.http.get(`${URL}`, httpOptions);
  }
  districts(id): any {
    return this.http.get(`${dynamicURL}district/list/${id}`, httpOptions);
  }

  AddActionExcelData(data) {
    return this.http.post(`${AddActionExcelData}`, data);
  }
  AddProperty(data) {
    return this.http.post(`${AddProperty}`, data);
  }
  GETAuctionAlertDetails(date: string, Field: string) {
    return this.http.get(
      `${GETAuctionAlertDetails}${date}?FilterField=${Field}`
    );
  }

  AuctionEmailSend(data) {
    return this.http.post(`${AuctionEmailSend}`, data);
  }

  GETAuction() {
    return GETAuction;
  }
  loginReport() {
    return loginReport;
  }
  getCountOfUser(franchise_Id: any, dates?: any) {
    if (
      franchise_Id !== null &&
      franchise_Id !== "null" &&
      franchise_Id !== undefined
    ) {
      if (dates) {
        return this.http.get(
          `${getCountOfUser}?franchise_Id=${franchise_Id}&endDate=${dates.endDate}&startDate=${dates.startDate}`
        );
      } else {
        return this.http.get(`${getCountOfUser}?franchise_Id=${franchise_Id}`);
      }
    } else {
      if (dates) {
        return this.http.get(
          `${getCountOfUser}?endDate=${dates.endDate}&startDate=${dates.startDate}`
        );
      } else {
        return this.http.get(`${getCountOfUser}`);
      }
    }
  }

  getUsersDetails(id: any) {
    return this.http.get(`${getcallAlertUserDetails}/${id}`);
  }

  getUsersCallDetails(id: any) {
    return this.http.get(`${getcallAlertUserDetails}/${id}`);
  }

  getCallAlertList(id) {
    return `${getCallAlertList}${id}`;
  }

  getCallAlertType() {
    return this.http.get(`${getCallAlertType}`);
  }

  getCallInitiatedFrom() {
    return this.http.get(`${getCallInitiatedFrom}`);
  }

  getActivationStatus() {
    return this.http.get(`${getActivationStatus}`);
  }
  addCallAlert(data: any) {
    return this.http.post(`${addCallAlert}`, data, httpOptions);
  }

  addFranchiseUser(UserDetails: any) {
    return this.http.post(`${addFranchiseUser}`, UserDetails, httpOptions);
  }

  updateFranchiseUser(UserDetails: any) {
    return this.http.post(`${updateFranchiseUser}`, UserDetails, httpOptions);
  }
  getFranchiseId() {
    return this.http.get(`${baseurl}api/franchise`);
  }

  callAlertList() {
    return `${callAlertList}`;
  }

  getAmountGraphData(franchise_Id?: any, dates?: any) {
    if (
      franchise_Id !== null &&
      franchise_Id !== "null" &&
      franchise_Id !== undefined
    ) {
      if (dates) {
        return this.http.get(
          `${amountGraphData}?franchise_Id=${franchise_Id}&endDate=${dates.endDate}&startDate=${dates.startDate}`
        );
      } else {
        return this.http.get(`${amountGraphData}?franchise_Id=${franchise_Id}`);
      }
    } else {
      if (dates) {
        return this.http.get(
          `${amountGraphData}?endDate=${dates.endDate}&startDate=${dates.startDate}`
        );
      } else {
        return this.http.get(`${amountGraphData}`);
      }
    }
  }
  getUsersStatusList() {
    return this.http.get(`${statusList}`);
  }

  getSubscriberList() {
    return `${getSubscriberList}`;
  }
  // getAmountGraphData(dates?:any){
  //   return this.http.get(`${amountGraphData}?&endDate=${dates.endDate}&startDate=${dates.startDate}`);
  // }
}
